const data = {
  pageName: "VBGDigitalJourneys",
  services: {
    translations: {
      url: "VBGDigitalJourneys/translations",
      params: {}
    },
    VBGvalidateAndGet: {
      url: "VBGDigitalJourneys/VBGvalidateAndGet",
      params: {}
    },
    submitVBGOrder: {
      url: "VBGDigitalJourneys/submitVBGOrder",
      params: {}
    },
    checkClickToCallRequest: {
      url: "clickToCall/checkClickToCallRequest",
      params: {}
    },
    checkClickToCallAvailability: {
      url: "clickToCall/checkClickToCallAvailability",
      params: {}
    }
  },
  c2cinfo: [
    {
      campaign: "International_AddOns",
      callinglist: "r_ebu_addon_eu",
      clicktocallversion: "NEW",
      clicktocallformphone: "2106703064",
      clicktocallformid: "Retention Business EU",
      clicktocallcalendar: "ebu"
    },
    {
      campaign: "DataAddOnVBG",
      callinglist: "r_ebu_add_on",
      clicktocallversion: "NEW",
      clicktocallformphone: "2104276979",
      clicktocallformid: "Retention Business Add on",
      clicktocallcalendar: "ebu"
    },
    {
      campaign: "VBG_Retention_Offer",
      callinglist: "r_ebu_renewal_activities",
      clicktocallversion: "NEW",
      clicktocallformphone: "2106703302",
      clicktocallformid: "Retention Business Mobile",
      clicktocallcalendar: "ebu"
    }
  ]
};

exports.data = data;
